import AirportCard from './AirportCard';

export default AirportCard;
